<div class="info-block">
  <app-info-icon></app-info-icon>
  <span class="info-text">當連線模式為規則模式時，套用規則。</span>
  <a routerLink="/help" class="link">
    <span>More in Helping Center</span>
    <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_312_1249)">
        <path d="M2.93593 1.74692L7.10813 6.10142C7.20997 6.2068 7.26053 6.34341 7.26053 6.47944C7.26053 6.61548 7.20997 6.7522 7.10813 6.85747L2.93593 11.212C2.72739 11.4306 2.38131 11.4377 2.16347 11.2283C1.94415 11.0204 1.93702 10.6728 2.1471 10.4557L5.97522 6.45891L2.14775 2.50321C1.93768 2.28674 1.94481 1.93856 2.16413 1.73052C2.38199 1.52111 2.72858 1.5284 2.93593 1.74692Z" fill="#FF5A5A" />
      </g>
      <defs>
        <clipPath id="clip0_312_1249">
          <rect width="7.29167" height="11.6667" fill="white" transform="translate(0.354004 0.666992)" />
        </clipPath>
      </defs>
    </svg>
  </a>
</div> 